<template>
  <b-form-group :label="inputLabel"
                label-for="file-upload"
                class="mb-4 position-relative"
                :class="{'text-primary' : aboveLimit, 'on-drag': isDragging }"
                :disabled="disabled"
  >
    <p v-if="aboveLimit && limitErrorMsg" class="small">{{ limitErrorMsg }}</p>
    <div
      :class="[fileClass, 'd-flex flex-column justify-content-center align-items-center p-4']"
    >
      <div
        class="service-lib-round-btn d-flex justify-content-center align-items-center bg-transparent border-0 p-0 mb-2 bg-gray-100"
      >
        <b-icon icon="upload" class="h3 mb-0" />
      </div>
      <h5 class="mb-0">
        {{ file ? fileUploadedLabel : fileToUploadLabel }}
      </h5>
      <div v-if="file && file.name"
           class="d-flex justify-content-between w-100 mt-4"
      >
        <div class="d-flex justify-content-between">
          <b-icon :icon="aboveLimit ? 'exclamation-triangle' : 'check'"
                  class="mr-2"
                  :class="disabled ? 'text-gray' : (aboveLimit ? 'text-primary' : 'text-success')"
          />
          <div class="d-flex flex-column">
            <p class="mb-0">{{ file.name }}</p>
            <p class="text-gray-700 mb-0 captioned-text">{{ fileSizeMB }} MB</p>
          </div>
        </div>
        <button
          class="no-outline d-flex justify-content-center bg-transparent border-0 p-0"
          :disabled="disabled"
          @click.prevent="clearFileInput"
        >
          <b-icon icon="trash" class="h3 mb-0" :class="disabled ? 'text-gray' : 'text-primary'" />
        </button>
      </div>
      <span class="divider bg-gray-300 w-100 my-3" />
      <button v-if="!file" :disabled="disabled" class="btn btn-primary">{{ selectFileLabel }}</button>
      <p v-if="!file && fileLimitationsLabel" class="text-gray-700 mb-0 mt-2 captioned-text">
        {{ fileLimitationsLabel }}
      </p>
    </div>
    <input v-if="!file"
           id="file-upload"
           accept=".pdf, image/*"
           :disabled="disabled"
           type="file"
           class="file-selector position-absolute w-100 h-100 zindex-3"
           :class="{'cursor-pointer' : !disabled}"
           @change="handleFileUpload"
           @dragenter="handleDragEnter"
           @dragleave="handleDragLeave"
           @dragover="handleDragOver"
    >
  </b-form-group>
</template>

<script>
export default {
  props: {
    file: {
      type: [Object, File, null]
    },
    fileSizeMB: {
      type: String,
      default: ''
    },
    maxSize: {
      type: Number,
      default: 4
    },
    limitErrorMsg: {
      type: String,
      default: 'The file is too large. Please upload a file up to 4MB.'
    },
    inputLabel: {
      type: String,
      default: 'Upload File (Optional)'
    },
    fileUploadedLabel: {
      type: String,
      default: 'Uploaded File:'
    },
    fileToUploadLabel: {
      type: String,
      default: 'Drag & Drop file here or use button to Select file:'
    },
    selectFileLabel: {
      type: String,
      default: 'Select File...'
    },
    fileLimitationsLabel: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isDragging: false
    }
  },
  computed: {
    aboveLimit() {
      return this.fileSizeMB > this.maxSize
    },
    fileClass() {
      if (!this.file) {
        return 'custom-dashed-border'
      }
      return this.disabled ? 'bg-gray-400' : (this.aboveLimit ? 'border-primary border rounded' : 'border-success border rounded')
    }
  },
  methods: {
    handleFileUpload(event) {
      this.isDragging = false
      const file = event.target.files[0]
      const fileSizeMB = this.calculateFileSizeInMB(file.size)
      this.$emit('fileUploaded', file)
      this.$emit('update:fileSizeMB', fileSizeMB)
    },
    clearFileInput() {
      this.$emit('clearFile')
    },
    calculateFileSizeInMB(sizeInBytes) {
      return (sizeInBytes / (1024 * 1024)).toFixed(2)
    },
    handleDragEnter() {
      this.isDragging = true
    },
    handleDragLeave() {
      this.isDragging = false
    },
    handleDragOver(event) {
      event.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
.divider {
  height: 1px;
}

.file-selector {
  top: 0;
  left: 0;
  opacity: 0;
}

.custom-dashed-border {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23717171' stroke-width='1' stroke-dasharray='6%2c 14' stroke-dashoffset='13' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 5px;
}

.on-drag {
  opacity: .6;
}
</style>
